export const normalizeSrList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string") {
    return value
      .split("\n")
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
};

export const getSrCountLimitError = ({ count, qty, label, productName }) => {
  const quantity = Number(qty) || 0;
  if (count <= quantity) return "";

  const prefix = productName ? `${productName}: ` : "";
  return `${prefix}${label} serial numbers count (${count}) cannot exceed quantity (${quantity})`;
};

export const validateSrCountWithinQty = ({ srNos, qty, label, productName }) =>
  getSrCountLimitError({
    count: normalizeSrList(srNos).length,
    qty,
    label,
    productName,
  });

export const validateChallanItemSrCounts = (items = []) => {
  for (const item of items) {
    if ((Number(item.deliveredQty) || 0) > 0) {
      const deliveredError = validateSrCountWithinQty({
        srNos: item.deliveredSrNos ?? item.srNo,
        qty: item.deliveredQty,
        label: "Delivered",
        productName: item.name,
      });
      if (deliveredError) return deliveredError;
    }

    if ((Number(item.receivedQty) || 0) > 0) {
      const receivedError = validateSrCountWithinQty({
        srNos: item.receivedSrNos ?? item.srNo,
        qty: item.receivedQty,
        label: "Received",
        productName: item.name,
      });
      if (receivedError) return receivedError;
    }
  }

  return "";
};
